export default __webpack_public_path__ + "static/media/ER.c27b5fdc.svg";